
const digest = 'f90208a8b7486b0f1127cbffeaf33665c4634878a8d2defbe531194e47f875b8';
const classes = {"wrapper":"_wrapper_n9r6o_1","text":"_text_n9r6o_6","text2":"_text2_n9r6o_11","checkboxes":"_checkboxes_n9r6o_17","buttonsWrapper":"_buttonsWrapper_n9r6o_20"};
const css = `._wrapper_n9r6o_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
}
._wrapper_n9r6o_1 ._text_n9r6o_6 {
  font-size: 14px;
  margin-bottom: 20px;
  margin-top: 20px;
}
._wrapper_n9r6o_1 ._text2_n9r6o_11 {
  font-size: 14px;
  margin-bottom: 20px;
  border-top: 1px solid #eaedf3;
  padding-top: 20px;
}
._wrapper_n9r6o_1 ._checkboxes_n9r6o_17 {
  margin-bottom: 20px;
}
._wrapper_n9r6o_1 ._buttonsWrapper_n9r6o_20 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  